<template>
  <div>
  
  
  
   <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;cursor:pointer;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
  
  
   <card>
        <h5 style="font-weight:bold;">Grant Access To Client Account</h5>

                
                
            
             <div class="col-sm-7">    
                 <fg-input type="text"
                  name="email"
                   v-validate="modelValidations.email"
				  label="Email Address Of Client Account (Please create the client account on the client portal before granting access)"         
				   :error="getError('email')"         
                  v-model="account.email">
       			 </fg-input>
            </div>
        
        	
        	
        	
        	<p-button    @click.prevent="createClientAccount()" type="info" >
           				Grant Access
   			 </p-button> 
    </card>
        
        
       
       
       <div style="margin-top:90px;">
       <h5 style="font-weight:bold;">Existing Client Accounts</h5>
  		</div>
		
        <div class="card" style="margin-bottom:50px">
          <div class="card-body table-responsive table-full-width">
            <el-table :data="clients">
                <el-table-column label="Email Address" property="email" ></el-table-column>
     			 <el-table-column label="Remove">
            		<template slot-scope="scope">
            			 <p-button type="danger" size="sm" icon @click="removeAccess(scope.row)">
                 			 <i class="nc-icon nc-simple-remove"></i>
                		</p-button>
					</template>
               </el-table-column>
               
               <el-table-column label="">
            		<template slot-scope="scope">
            			 <p-button type="success" size="sm"  @click="sendEmail(scope.row)">
                 			 Send Welcome Email
                		</p-button>
					</template>
               </el-table-column>
               
               
                 
            </el-table>

          </div>
        </div>
        
        
        
  
    </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {

      	this.initPage();
    },
    
     
    data () {
      return {
        coy:[],
        clients:[],
    	eid: this.$route.params.eid,
		account: {
          email: '',
        },
        modelValidations: {
          title: {
          },
          description: {
          },
          email: {
            required: true,
            email:true,
          },
          due_date: {
          	required: true,
          },
         
          
        },
      }
    },
    methods:{
      goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
	    getError(fieldName) {
        return this.errors.first(fieldName)
      },
      
      removeAccess(row){
      		const vm = this;
      		swal({
					title: 'Are you sure?',
					text: 'Access will be removed for this client.',
					type: 'warning',
					showCancelButton: true,
					confirmButtonClass: 'btn btn-success btn-fill',
					cancelButtonClass: 'btn btn-danger btn-fill',
					confirmButtonText: 'Yes',
					buttonsStyling: false
				  }).then(function () {
					 const vm2 = vm;
					 let uri = vm.$base_url+'/api/v1/entities/post/remove_access/' +  vm.$route.params.eid;
					
					 ApiService.post(uri, row).then(response => {
	
							swal({
							  title: 'Access Removed',
							  text: 'Access has been removed successfully.',
							  type: 'success',
							  confirmButtonClass: 'btn btn-success btn-fill',
							  buttonsStyling: false
							}).then(function () {
								vm2.initPage();
							
							})
							//end swal
						
						
					})


				  })//end swal
      
      },
      sendEmail(row){
      		alert("Feature is currently not activated.");
      		
      		return "";
      
      
      		const vm = this;
      		swal({
					title: 'Are you sure?',
					text: 'A welcome email will be sent to this client.',
					type: 'warning',
					showCancelButton: true,
					confirmButtonClass: 'btn btn-success btn-fill',
					cancelButtonClass: 'btn btn-danger btn-fill',
					confirmButtonText: 'Yes',
					buttonsStyling: false
				  }).then(function () {
				  	
					 const vm2 = vm;
					 let uri = vm.$base_url+'/api/v1/entities/post/send_email/' +  vm.$route.params.eid;
					
					 ApiService.post(uri, row).then(response => {
	
							swal({
							  title: 'Done',
							  text: 'Email has been sent successfully.',
							  type: 'success',
							  confirmButtonClass: 'btn btn-success btn-fill',
							  buttonsStyling: false
							}).then(function () {
								//vm2.initPage();
							
							})
							//end swal
						
						
					})


				  })//end swal

      },
	  createClientAccount(){
	    	 this.$validator.validateAll().then(isValid => {
         	 if (!isValid) {
    		
  		 	 } else {
				const vm = this;

				swal({
					title: 'Are you sure?',
					text: 'Please make sure a client account with this email address has already been created.',
					type: 'warning',
					showCancelButton: true,
					confirmButtonClass: 'btn btn-success btn-fill',
					cancelButtonClass: 'btn btn-danger btn-fill',
					confirmButtonText: 'Yes',
					buttonsStyling: false
				  }).then(function () {
					 const vm2 = vm;
					 let uri = vm.$base_url+'/api/v1/entities/post/grant_access/' +  vm.$route.params.eid;
					
					 ApiService.post(uri, vm.account).then(response => {
					 	var csr = response.data.csr;
					 	if(csr){
					 
							swal({
							  title: 'Access Granted',
							  text: 'Access to this company has been granted to the client account',
							  type: 'success',
							  confirmButtonClass: 'btn btn-success btn-fill',
							  buttonsStyling: false
							}).then(function () {
								vm2.initPage();
							
							})
							//end swal
						}
						else{
							swal({
								  title: 'Error!',
								  text: "No client account with this email address exists or access has already been given to the account with this email address",
								  type: 'error',
								  confirmButtonClass: 'btn btn-success btn-fill',
								  buttonsStyling: false
							})
	
						
						}
					})


				  })//end swal
	    	}//end if-else
	    	})//end validator
	    },
	    initPage(){
	    	let uri = this.$base_url+'/api/v1/entities/get/client_accounts/'+ this.$route.params.eid;
			 ApiService.get(uri).then(response => {
				this.coy = response.data.entity;
				this.clients = response.data.clients;
			})
	    },
	   
	  
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


